"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDestinationPluginWithAddMiddleware = void 0;
var isDestinationPluginWithAddMiddleware = function (plugin) {
    // FYI: segment's plugin does not currently have an 'addMiddleware' method
    return 'addMiddleware' in plugin && plugin.type === 'destination';
};
exports.isDestinationPluginWithAddMiddleware = isDestinationPluginWithAddMiddleware;
//# sourceMappingURL=index.js.map